module.exports = __webpack_public_path__ + "img/WelfarebitPoweredTodoba.04bb34f8.jpg";